module.exports = __webpack_public_path__ + "static/media/Categories-Unselected-Icon-2x.fe0158f3.png";